import { DeviceModel } from "src/gen/schema/models/bom";
import { DeviceOrderableType } from "src/gen/schema/models/fabric";

export type DeviceModelVisibilityPredicate = (
  model: string | undefined
) => boolean;

export const BINDABLE_DEVICE_MODEL_REQUIRED_MESSAGE =
  "Binding is available after the device ships and is claimed.";

const BINDABLE_ORDERABLE_TYPES = new Set<DeviceOrderableType>([
  DeviceOrderableType.DEVICE_ORDERABLE_TYPE_BINDABLE,
  // EOS should be included because backend enum says EOS devices are still allowed for binding.
  DeviceOrderableType.DEVICE_ORDERABLE_TYPE_EOS
]);

export const isBindableDeviceModel = (deviceModel?: DeviceModel): boolean => {
  if (window.cnc?.settings?.get("enableBindableDeviceModelCheck") === false) {
    return true;
  }

  return (
    !!deviceModel && BINDABLE_ORDERABLE_TYPES.has(deviceModel.orderableType)
  );
};
/**
 * Determines if a device model should be visible in the UI.
 * DEVICE_ORDERABLE_TYPE_UNSPECIFIED models are hidden unless the
 * "showUnspecifiedDeviceModels" developer setting is enabled.
 *
 */
export const isVisibleDeviceModel = (deviceModel?: DeviceModel): boolean => {
  if (!deviceModel) {
    return false;
  }

  if (
    deviceModel.orderableType ===
    DeviceOrderableType.DEVICE_ORDERABLE_TYPE_UNSPECIFIED
  ) {
    return Boolean(window.cnc?.settings?.get("showUnspecifiedDeviceModels"));
  }

  return true;
};
